// @flow
import { createStore, applyMiddleware } from "redux"
import { persistStore } from "redux-persist"
import { connectRouter, routerMiddleware } from "connected-react-router"
import { composeWithDevTools } from "redux-devtools-extension"
import history from "global/history"
import reducers from "./reducers"
import epicMiddleware from "./epicMiddleware"

const middlewares = [epicMiddleware, routerMiddleware(history)]

const store = createStore(
  connectRouter(history)(reducers),
  {},
  composeWithDevTools(applyMiddleware(...middlewares)),
)

export const persistor = persistStore(store)

export const purgePersistor = (): void => persistor.purge()

export default store



// WEBPACK FOOTER //
// ./src/global/store/index.js